<template>
<div>
    <v-container>
        <v-row>
            <span class="centered text-centered display-1 font-weight-light">{{question.question}}</span>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="8" md="6">
            <img src="/help_icon.png" class="bulb-icon" @click="showHelperText = !showHelperText">
            <span :class="showHelperText ? 'visible help-text' : 'hidden help-text'" v-html="question.helper_text"></span>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col class="col-6 margin-top">
                <v-file-input 
                    @change="inputFile" 
                    v-model="this.file"
                    :clearable="false"
                    label="File input">
                </v-file-input>
            </v-col>
        </v-row>
    </v-container>
</div>
</template>
<script>
import axios from 'axios'
import Client, {upload} from '../client.js'

export default {
    props: {
        stage_key: String,
        sort: [String, Number],
        application_id: [String, Number]
    },
    // computed: {
    //     currentQuestion() {
    //         console.log('compute')
    //         if(this.questions.length === 0) {
    //             return null;
    //         }
    //         return this.questions.find(item => item.sort === Number(this.sort));
    //     }
    // },
    data: function () {
        return {
            question: {},
            file: null,
            showHelperText: true
        }
    },
    mounted() {
        this.fetchData(this.sort);
    },
    watch: {
        'sort': function (sort) {
            this.clearState();
            this.fetchData(sort);
        }
    },
    methods: {
        async fetchData(sort) {
            let client = Client();
            let ress = await axios.all([
                client.get(`/stages/${this.stage_key}/questions/${sort}`),
            ]);
            this.question = ress[0].data;
            let ress2 = await axios.all([
                client.get(`/applications/${this.application_id}/questions/${this.question.id}`)
            ]);
            if(ress2) {
                const link = ress2[0].data.answer;
                const name = link.split(`${this.stage_key}/`)[1];
                this.file = new File([name], `${name}.txt`, {type: 'text/plain'})
            }
        },
        inputFile(event) {
            console.log(event);
            this.file = event;

            const formData = new FormData();
            formData.append('file', this.file);
            upload(`/applications/${this.application_id}/questions/${this.question.id}`, formData);
        },
        clearState() {
            this.question = {};
            this.file = null;
        }
    }
}
</script>
<style lang="scss" scoped>
.centered {
    margin-left: auto;
    margin-right: auto;
    display: block;
    // width: 70%
}

.text-centered {
    text-align: center;
}

.margin-top {
    margin-top: 10%;
}
.help-text {
    font-family: $secondary-font;
}
.visible {
    display: inline;
}

.hidden {
    display: none;
}
</style>